import { LocaleDictionaryType, useLanguage } from "@/lib/main";

const notAvailable: LocaleDictionaryType = {
  ar: "❎",
  en: "❎",
  // * Add other languages as needed
};

const useLocales = () => {
  const { language } = useLanguage();

  const localize = (term: LocaleDictionaryType): string => {
    if (typeof term === "string") return term;
    return term[language] || notAvailable[language] || "Locale Not Found";
  };

  return localize;
};

export default useLocales;
